export default __webpack_public_path__ + "static/media/group-org1.19f13520.jpg";